// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.inputs-container{display:flex;justify-content:space-between;align-items:center;-moz-column-gap:30px;column-gap:30px;width:100%}.inputs-container>*{flex-basis:50%}`, ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
